/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { isNone } from '@ember/utils';
import Refinement from 'cio/app-models/conditions/refinement';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import EnvironmentService from 'cio/services/environment';
import EventCondition from 'cio/app-models/conditions/event';
import AuthService from 'cio/services/auth';

interface CioConditionEditorEventArgs {
  // backwards compat
  classNames: string;
  condition: EventCondition;
  allowMessageWildcardSelection?: boolean;
  allowInParentWildcardSelection?: boolean;
  inverseOptions: { value: boolean; label: string }[];
  depth: number;
  actionItems: { value: boolean; label: string }[];
  customerItems: { value: boolean; label: string }[];
  canDuplicate?: boolean;
  changetype: () => unknown;
  onRemove: () => unknown;
  onDuplicate?: () => unknown;
  disabled: boolean;
}

export default class CioConditionEditorEvent extends Component<CioConditionEditorEventArgs> {
  @service auth!: AuthService;
  @service environment!: EnvironmentService;

  readonly attributeNames = []; // FUTURE: fetch attribute names for selected event name?

  get inverseOptions() {
    return (
      this.args.inverseOptions ?? [
        { value: false, label: 'has been performed' },
        { value: true, label: 'has not been performed' },
      ]
    );
  }

  @computed('args.condition.{refinement,filters}')
  get isRefined() {
    let { refinement, filters } = this.args.condition;

    return !isNone(refinement) || filters.length > 0;
  }

  @action
  addRefinement() {
    this.args.condition.set('refinement', Refinement.create());
  }

  @action
  removeRefinement() {
    this.args.condition.set('refinement', null);
  }

  @action
  addFilter() {
    let condition = EventAttributeCondition.create({
      event: this.args.condition.name,
      name: '',
      operator: 'eq',
      value: '',
    });

    this.args.condition.filters.pushObject(condition);
  }

  @action
  removeFilter(filter: EventAttributeCondition, _index: number) {
    this.args.condition.filters.removeObject(filter);
  }

  @action
  duplicateFilter(filter: EventAttributeCondition) {
    let duplicate = filter.duplicate();
    this.args.condition.set('filters', [...this.args.condition.filters, duplicate]);
  }

  get depthClassModifier() {
    return `${this.args.depth % 2 === 0 ? 'even' : 'odd'}`;
  }
}
